import React from "react";
import { Container, Row, Col } from "reactstrap";
import katyContact from '../Assets/Images/katy.png';
import juanContact from '../Assets/Images/juan.png';
import martaContact from '../Assets/Images/marta.png';

import styles from "./Testimonial.module.css";

const Testimonial = () => {
  return (
    <section name="Testimonios" className={styles.testimonios}>
      <div className={styles.capa}>
      <Container className={styles.contentScreen}>
        <div className={styles.titleContainer}>
          <h1 className={styles.title}>Comunicarse es esencial</h1>
          <h3 className={styles.subtitle}>para nuestro buen hacer.</h3>

        </div>

        <Row>
          <Col lg="6" md="6" className={styles.colOne}>
            <div className={styles.testimonialImg}>
              <img
                src={juanContact}
                className={styles.testimonialLogo}
                alt="contacto de juan muñoz"
              />
            </div>
          </Col>

          <Col lg="6" md="6" className={styles.colTwo}>
            <div className={styles.testimonialContent}>
              <h3 className={styles.titleSmall}>Juan Muñoz</h3>

              <div className={styles.singleTestimonial}>
                <p className={styles.content_p}>
                  Haber trabajado con Bonfer Tech, yo lo definiría como que ha
                  sido un lujo. Recuerdo los primeros "feedback" que recibíamos
                  en las primeras reuniones y aunque todos sabíamos que era un
                  proyecto único y diferenciador, donde se tenía que trabajar
                  desde cero, siempre todo el equipo de <b>econometra</b> recibía la
                  misma sensación: tranquilidad. Sabíamos que estábamos en
                  manos de una profesional. Ahora, después de unos meses, podemos
                  decir que esa tranquilidad se confirmó, pues se ha
                  desarrollado una APP, que no tan solo da solución a una
                  tipología de eventos, si no que va a provocar un cambio
                  digitalizador en cuanto a cómo se puede afrontar de manera
                  individualizada este tipo de litigios (Cártel de Vehículos).
                </p>
                <div className={styles.info}>
                  <h5 className="fw-bold">Econometra (agosto 2024).</h5>

                  <h5 className="fw-bold">Ingeniero Técnico Industrial</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="6" md="6" className={styles.colOne} >
            <div className={styles.testimonialImg}>
              <img
                src={martaContact}
                className={styles.testimonialLogo}
                alt="contacto de marta garcía"
              />
            </div>
          </Col>

          <Col lg="6" md="6" className={styles.colTwo}>
            <div className={styles.testimonialContent}>
              <h3 className={styles.titleSmall}>Marta García</h3>

              <div className={styles.singleTestimonial}>
                <p className={styles.content_p}>
                  Nos sentimos afortunados de haber contado con Bonfer Tech para
                  el desarrollo de nuestra primera aplicación, <b>Econometra</b>.
                  Partimos de una simple idea y, gracias a su experiencia y
                  pericia, logramos darle forma de manera extraordinaria,
                  superando nuestras expectativas. Lo que realmente destaca de
                  Bonfer Tech es su habilidad para resolver problemas y
                  anticiparse a los desafíos, el resultado ha sido una aplicación
                  intuitiva, útil y fácil de usar para nuestros usuarios. La
                  colaboración fue fluida, formando un equipo
                  cohesionado, con una comunicación clara y constante que nos
                  mantuvo informados en cada etapa del desarrollo. Bonfer Tech
                  demostró ser un equipo de desarrollo competente, confiable y
                  comprometido. Recomiendo sinceramente a Bonfer Tech para el
                  desarrollo de cualquier aplicación o sitio web; su trabajo y
                  profesionalidad han sido fundamentales para el éxito de Econometra.
                </p>
                <div className={styles.info}>
                  <h5 className="fw-bold">Econometra (agosto 2024).</h5>

                  <h5 className="fw-bold">
                    Economista especialista econométrico.
                  </h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col lg="6" md="6" className={styles.colOne}>
            <div className={styles.testimonialImg}>
              <img
                src={katyContact}
                className={styles.testimonialLogo}
                alt="contacto de katy muñoz"
              />
            </div>
          </Col>

          <Col lg="6" md="6" className={styles.colTwo}>
            <div className={styles.testimonialContent}>
              <h3 className={styles.titleSmall}>Katy Muñoz</h3>

              <div className={styles.singleTestimonial}>
                <p className={styles.content_p}>
                Teníamos una idea y no sabíamos cómo darle forma,  contactamos con Bonfer Tech y nos dió la solución, ha desarrollado una APP (<b>Econometra</b>), que es una herramienta especializada en las reclamaciones debidas al cartel de coches y que satisface todos los requerimientos técnicos y estéticos que necesitábamos.
                </p>
                <div className={styles.info}>
                  <h5 className="fw-bold">Econometra (agosto 2024).</h5>

                  <h5 className="fw-bold">Departamento de gestión.</h5>
                </div>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
      </div>
    </section>
  );
};

export default Testimonial;
